import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Container, Grid, Paper } from '../../../components/mui/Core/index'
import GenericNav from '../../../components/genericcomponents/navbars/GenericNav'
import ItemDetailsCard from '../components/ItemDetailsCard/item-details-card'
import ItemSpecialPricingTable from './components/ItemSpecialPricingTable/item-special-pricing-table'
import useBrowserTabTitles from '../../../hooks/browserTabTitles/browser-tab-titles'
import PageTitle from '../../../components/PageTitle/page-title'
import Constants from '../../../constants/en.json'
import { sessionStorageKeyConstants } from '../../../constants/session-storage-key-constants'

function ItemSpecialPricing() {
  const selectedInventoryItem = useSelector((state) => state.inventory.selectedInventoryItem)
  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const pageTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${Constants.itemSpecialPricing.NDC_ITEM_NUMBER} ${selectedInventoryItem?.itemNumber} - ${Constants.itemSpecialPricing.SPECIAL_PRICING}`
    : `${Constants.itemSpecialPricing.NDC_ITEM_NUMBER} ${selectedInventoryItem?.itemNumber} - ${Constants.itemSpecialPricing.SPECIAL_PRICING}`
  const browserTabTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${Constants.itemSpecialPricing.SPECIAL_PRICING} - ${Constants.itemSpecialPricing.NDC_ITEM_NUMBER} ${selectedInventoryItem?.itemNumber}`
    : `${Constants.itemSpecialPricing.SPECIAL_PRICING} - ${Constants.itemSpecialPricing.NDC_ITEM_NUMBER} ${selectedInventoryItem?.itemNumber}`
  useBrowserTabTitles(browserTabTitle)

  return (
    <Box sx={{ flexGrow: 1 }}>
      <GenericNav selected='Inventory' user='authenticated' />
      <Container maxWidth='xl'>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <PageTitle title={pageTitle} />
          </Grid>
          <Grid size={{ xs: 12 }} sx={{ py: 5 }}>
            <ItemDetailsCard />
            {/* Search Component */}
            <ItemSpecialPricingTable />
          </Grid>
        </Grid>
        <Paper sx={{ width: '100%', mb: 2 }} />
      </Container>
    </Box>
  )
}

export default ItemSpecialPricing
